import { render } from "./KnowledgeMap.vue?vue&type=template&id=194517ff&scoped=true"
import script from "./KnowledgeMap.vue?vue&type=script&lang=js"
export * from "./KnowledgeMap.vue?vue&type=script&lang=js"

import "./KnowledgeMap.vue?vue&type=style&index=0&id=194517ff&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194517ff"]])

export default __exports__